import React from 'react';
import './App.scss';
import Fretboard from "./components/Fretboard/Fretboard";

function App() {
  return (
    <div className="App justify-content-center">
        <Fretboard></Fretboard>
    </div>
  );
}

export default App;
